import { ADMIN_DASHBOARD_COPY } from '@sonar-software/sonar-ts-constants';
import { Button } from 'antd';
import { ConfirmDeleteIcon } from '@ui/modals';
import React, { useCallback } from 'react';
export const OidcProviderDeleteButton = (props) => {
    const { isEnteringNewData, onCleared, onDeleted } = props;
    const handleConfirmDelete = useCallback(() => {
        if (onDeleted) {
            onDeleted();
        }
    }, [onDeleted]);
    return (React.createElement("span", null,
        isEnteringNewData &&
            React.createElement(Button, { className: 'oidc-provider-clear-link', onClick: onCleared, type: 'text' }, ADMIN_DASHBOARD_COPY.CLEAR),
        !isEnteringNewData &&
            React.createElement(ConfirmDeleteIcon, { cancelButtonProps: {
                    value: ADMIN_DASHBOARD_COPY.NO
                }, confirmButtonProps: {
                    value: ADMIN_DASHBOARD_COPY.YES
                }, iconClassName: 'oidc-provider-delete-link', onConfirm: handleConfirmDelete, title: ADMIN_DASHBOARD_COPY.DELETE_OIDC_CONFIG_CONFIRMATION })));
};
